import { useCallback } from "react";

export const useCopyToClipboard = (onSuccess?: (text: string) => void, onError?: (error: unknown) => void) => {
	return useCallback(
		async (text: string) => {
			try {
				await navigator.clipboard.writeText(text);
				onSuccess?.(text);
			} catch (error) {
				onError?.(error);
			}
		},
		[onError, onSuccess],
	);
};
